<template>
  <div class="sorting__options">
    <SortingOption
      v-for="(option, i) in options"
      name="desktop-sorting"
      :option="option"
      :activeOption="activeOption"
      :index="i"
      :key="option.code"
      @selected="$emit('selected', $event)"
    />
  </div>
</template>

<script>
import SortingOption from './SortingOption/SortingOption.vue'

export default {
  name: 'SortingOptions',
  components: { SortingOption },
  props: {
    sortOptions: {
      type: Object,
      required: true,
    },
    activeOption: {},
  },
  computed: {
    options() {
      return Object.values(this.sortOptions)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './Sorting';
</style>
